import { WizardTranslations } from "./wizard-pt-br";

export const WIZARD_EN_US: WizardTranslations = {
	common: {
		pointsOfSale: "Points of sale",
	},
	welcome: {
		title: "Welcome, <placeName>{{placeName}}</placeName>!",
		subtitle: "Choose how you want to configure your operation.",
		skipButton: "I don't want to configure now",
		placeIdNotFound: "Place ID not found",
		features: {
			preConfiguredSteps: "Steps with pre-configured suggestions",
			guidedStepsWithAI: "Step-by-step guided with AI help",
			advancedConfigurations: "Advanced configurations and customizations",
			complexFeatures: "More complex features",
		},
		guidedMode: {
			title: "Guided creation (simplified mode)",
			subtitle: "We guide you step by step",
			buttonText: "Access simplified mode",
			features: {
				basicConfigurations: "More basic configurations",
				idealForSimpleOperations: "Ideal for simpler and smaller operations",
			},
		},
		advancedMode: {
			title: "Advanced creation",
			subtitle: "More options and configuration details",
			buttonText: "Access advanced mode",
			features: {
				directConfiguration: "Direct configuration in Dashboard modules",
				idealForComplexOperations: "Ideal for large and complex operations",
			},
		},
	},
	container: {
		stepIndexTitle: "Configure your place",
		buttons: {
			back: "Back",
			close: "Close",
			next: "Next",
			configureLater: "Configure later",
			finishConfiguration: "Finish configuration",
		},
		finishConfirmation: {
			title: "Complete operation settings",
			descriptionPart1: "You are about to complete the configuration of this operation.",
			descriptionPart2:
				"A final summary will be generated and will be available for consultation at any time. Afterwards, you will be able to review and edit when necessary.",
			cancelButton: "Cancel",
			confirmButton: "Finish configuration",
			successMessage: "Settings saved successfully!",
		},
		closeModalConfirmation: {
			title: "Exit configuration without saving?",
			description:
				"By closing now, the information configured so far will not be saved and you will lose progress. Do you want to continue?",
			cancelButton: "Continue configuring",
			confirmButton: "Exit without saving",
		},
		steps: {
			basicInformation: {
				title: "Basic information",
				subtitle: "Configure the operation type",
				operationType: {
					title: "How will customers <highlight>purchase</highlight>?",
					subtitle: "Choose one or more formats that will apply to this operation.",
					alert: {
						message: "These options are already marked from your operation contract.",
						description: "You can keep it as is or adjust if you wish.",
					},
					subStepTitle: "Operation type",
				},
				funcionalities: {
					title:
						"What will be the <highlight>functionalities</highlight> of this operation?",
					subtitle:
						"Functionalities are options with resources that allow configuring the operation in a personalized way.",
					subStepTitle: "Functionalities",
					searchFunctionalities: "Search by functionality",
					placeholderSearchFunctionalities: "Enter here the functionality",
					activeLabel: "active",
					loadingText: "Loading functionalities...",
					emptySearchResults: "No functionality found",
				},
				review: {
					title:
						"We have already understood the <highlight>initial configurations</highlight> of the operation!",
					subtitle: "According to your answers, the system will configure:",
					subStepTitle: "Review",
					reviewTitle: "Review the answers",
					reviewSubtitle: "You can edit them now or when you need to.",
					editStep: "Edit step",
					operationTypeLabel: "Operation Type",
					functionalitiesLabel: "Functionalities",
					notInformed: "Not informed",
					selectedCount: "{{count}} selected",
					viewFunctionalities: "View functionalities",
				},
			},
			pointsOfSale: {
				title: "Points of sale",
				subtitle: "Configure sales locations",
			},
			menu: {
				title: "Menu",
				subtitle: "Configure products",
			},
			employees: {
				title: "Employees",
				subtitle: "Configure the operation team",
			},
		},
		operationTypes: {
			token: {
				label: "Token",
				description: "Customer exchanges token for product",
			},
			cashlessPrepaid: {
				label: "Cashless (prepaid)",
				description: "Customer loads credit on a card",
			},
			cashlessPostpaid: {
				label: "Cashless (postpaid)",
				description: "Customer pays on a card after consumption",
			},
			directSale: {
				label: "Direct sale at bar",
				description: "Customer pays for the product directly",
			},
			tables: {
				label: "Tables",
				description: "Customer places order with waiters",
			},
		},
		summary: {
			title: "Configuration summary for <placeName>{{placeName}}</placeName>!",
			subtitle: "Edit answers, go back steps or access advanced settings at any time.",
			editStep: "Edit step",
			operationType: "Operation type",
			functionalities: "Functionalities",
			viewFunctionalities: "View functionalities",
			advancedConfigurations: "Advanced Functionality Settings",
			notInformed: "Not informed",
			selectedCount: "{{count}} selected",
			pendingAction: "Pending action",
			loading: "Loading settings...",
			placeIdNotFound: "Place ID not found",
			errorLoading: "Error loading data",
		},
	},
	components: {
		pdvCard: {
			menu: {
				edit: "Edit",
				remove: "Remove",
				ariaLabel: "Options menu",
			},
			buttons: {
				cancel: "Cancel",
				save: "Save",
			},
		},
		productCard: {
			menu: {
				edit: "Edit",
				remove: "Remove",
				ariaLabel: "Options menu",
			},
		},
		menuCard: {
			productsCount: "{{count}} products",
		},
		empty: {
			title: "No data found",
			description: "It seems there is no data to display.",
			button: "Add new item",
		},
		attachmentsFile: {
			loadingText: "Please wait while we send the file...",
			dragText: "Drag and drop the file",
			clickText: "or click to select",
			fileTypeText: "File type {{fileType}} up to {{fileSize}}.",
			maxSizeExceeded: "The file size exceeds the allowed limit.",
		},
		modalSelectImage: {
			productImage: "Edit image",
			setTagInput: "search for the product using keywords",
			notInformed: "Name not informed",
			confirm: "Confirm",
			selectFrom: "Select image from your ",
			computer: "computer",
			addImage: "Add image",
			typeOfFile: "File type .jpg, .jpeg, .png up to 5MB",
			errorCreatingImageUrl: "Error creating image URL",
		},
		employeePdvLink: {
			manualDistribution: "Distribute manually",
			description:
				"Choose for which points of sale all <strong>{{count}} {{roleName}}</strong> will work",
			selectedCount: "{{count}} Selected",
		},
	},
};
